<template>
    <div class="pa-10px py-md-16px">
        <slot />
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>